import {
  CurrencyInput,
  FormErrorMessage,
  Grid,
  Stack,
  Text,
} from '@zorro/web/design-system';
import {
  EnrollmentConfirmationFormFields,
  useAnalytics,
} from '@zorro/web/shared-ui';
import { Controller, UseFormReturn } from 'react-hook-form';

type Props = {
  sectionNumber: number;
  onboardingPeriodId: string;
  enrollmentConfirmationForm: UseFormReturn<EnrollmentConfirmationFormFields>;
};

export const EnrollmentPremiumAmountsSection = ({
  sectionNumber,
  onboardingPeriodId,
  enrollmentConfirmationForm,
}: Props) => {
  const { sendEvent } = useAnalytics();
  const { control, formState, watch } = enrollmentConfirmationForm;
  const premium = watch('premium');

  return (
    <Stack my="xl" ml="xs" gap="xxs">
      <Text w="100%" size="md" fw={600}>
        {sectionNumber}. Premium amount
      </Text>
      <Stack ml="md" gap="md">
        <Text size="sm" c="var(--color-text-default-secondary)">
          Verify or update the premium amount based on what the carrier is
          reflecting
        </Text>
        <Grid>
          <Grid.Col span={5}>
            <Stack gap="xs">
              <Controller
                control={control}
                name="premium"
                render={({ field: { ...rest } }) => (
                  <CurrencyInput
                    {...rest}
                    decimalScale={2}
                    prefix="$"
                    size="md"
                    onBlur={async () => {
                      if (formState.defaultValues?.premium !== premium) {
                        await sendEvent('edit_premium', {
                          onboarding_period_id: onboardingPeriodId,
                          from_premium: formState.defaultValues?.premium || 0,
                          to_premium: premium,
                        });
                      }
                    }}
                  />
                )}
              />
              <FormErrorMessage errors={formState.errors} fieldName="premium" />
            </Stack>
          </Grid.Col>
        </Grid>
      </Stack>
    </Stack>
  );
};
